<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
  >
    <header-component></header-component>
    <sidebar-component></sidebar-component>
    <main id="main-container">
      <div class="bg-body-light border-top border-bottom">
        <div class="content content-full py-1">
          <div class="block block-bordered">
            <div class="block-header block-header-default">
              <h3 class="block-title">Widget <small>Section</small></h3>
              <div class="block-options">
                <a
                  :href="'widget-editor/' + $route.params.id"
                  class="btn btn-sm text-primary"
                  data-toggle="tooltip"
                  title="Edit"
                >
                  <i class="fa fa-pencil-alt"></i>
                </a>
                <a
                  class="btn btn-sm text-warning"
                  data-toggle="tooltip"
                  title="Save as draft"
                >
                  <i class="fas fa-archive"></i>
                </a>
              </div>
            </div>
            <div class="block-content pb-5">
              <div class="content" v-if="widget.data != null">
                <div v-html="widget.data.contents"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import HeaderComponent from "../../components/layout/Header";
import SidebarComponent from "../../components/layout/Sidebar";
import { mapActions, mapState } from "vuex";

export default {
  name: "WidgetView",
  components: {
    HeaderComponent,
    SidebarComponent
  },
  beforeCreate() {
    this.$store.commit("widgets/CLEAR_WIDGET");
  },
  created() {
    this.getWidgetById(this.$route.params.id).then(response => {
      console.log("widget", response);
    });
  },
  computed: mapState({
    widget: state => state.widgets.widgetStateData
  }),
  methods: {
    ...mapActions({
      getWidgetById: "widgets/getWidgetById"
    })
  }
};
</script>

<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  display: none;
}

.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}
</style>
